/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

/**
 * 
 */
export class FaxWebhookApi extends runtime.BaseAPI {

    /**
     */
    async faxWebhookControllerHandleIncomingFaxRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/webhook/fax/sinch/incoming`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async faxWebhookControllerHandleIncomingFax(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.faxWebhookControllerHandleIncomingFaxRaw(initOverrides);
    }

    /**
     */
    async faxWebhookControllerHandleOutboundCompletedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/webhook/fax/sinch/completed`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async faxWebhookControllerHandleOutboundCompleted(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.faxWebhookControllerHandleOutboundCompletedRaw(initOverrides);
    }

}
